<template>
  <div>
    <h4
      class="d-flex justify-content-between align-items-center w-100 font-weight-bold py-3 mb-4"
    >
      <div class="e-mtavr-15">მომხმარებლების მართვა</div>
    </h4>

    <div class="row">
      <div class="col-12">
        <div class="e-loader-back" v-if="usersLoading">
          <div class="e-loader-content">
            <div class="ball-clip-rotate-multiple">
              <div></div>
              <div></div>
            </div>
            <div class="e-nusx-8 e-bold e-loader-text">იტვირთება...</div>
          </div>
        </div>
        <vue-good-table
          ref="UserTable"
          :columns="userTableColumns"
          :rows="userTableRows"
          class="vgt-table bordered condensed e-table-1 e-dynamic-filter"
          :search-options="{
            enabled: true,
            placeholder: 'ძებნის პარამეტრი',
          }"
          :sort-options="{
            enabled: false,
            // initialSortBy: { field: 'id', type: 'asc' },
          }"
          :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 10,
            position: 'top',
            perPageDropdown: [15, 25, 50],
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: 'შემდეგი',
            prevLabel: 'წინა',
            rowsPerPageLabel: 'ნაჩვენები ჩანაწერების რაოდენობა',
            ofLabel: '-ჩანაწერი სულ',
            pageLabel: 'გვერდი', // for 'pages' mode
            allLabel: 'ყველა',
          }"
        >
        <div slot="table-actions">
                   <b-button
                class="btn btn-link e-mtavr-17 btn-outline-secondary mr-2"
                v-b-modal.addNewUser
              >
                <i class="lnr lnr-file-add mr-2"></i> ახალი მომხმარებელი
              </b-button>
               </div>
          <template slot="table-row" slot-scope="props">
            <div v-if="props.column.field == 'functions'" class="text-left">
              <b-btn
              v-if="props.row.statusID > 0"
                class="btn btn-xs btn-outline-success borderless icon-btn"
                v-b-modal.editUserDetails
                @click="EditUser(props.row)"
              >
                <i class="lnr lnr-pencil"></i>
              </b-btn>
              <!-- <b-btn
              v-if="props.row.statusID > 0"
                class="btn btn-xs btn-outline-secondary borderless icon-btn"
                v-b-modal.changePassword
                @click="ChangePassword(props.row)"
              >
                <i class="lnr lnr-cog"></i>
              </b-btn> -->
              <button
                type="button"
                class="btn btn-xs btn-outline-danger borderless icon-btn"
                @click="EditUser2Del(props.row)"
                v-if="props.row.statusID > 0"
              >
                <i class="lnr lnr-cross"></i>
              </button>
            </div>
            <div v-else-if="props.column.field == 'statusText'" class="text-right">
              <span v-if="props.row.statusID > 0" class="text-success e-nusx-8">აქტიური</span>
              <span v-if="props.row.statusID ===0" class="text-danger e-nusx-8">გაუქმებული</span>
            </div>
          </template>
        </vue-good-table>
      </div>
    </div>
    <add-new-user @UserAdded="GetOrgUsers()"></add-new-user>
    <edit-user-details :EditUserDetails="UpdateUserItem"></edit-user-details>
    <change-password :changePasswordParams="changePasswordItem"></change-password>
  </div>
</template>
<script>
import BaseService from '@/backend/vue-axios/axios.js'
import addNewUser from './components/addNewUser.vue'
import editUserDetails from './components/editUser'
import changePassword from './components/changePassword.vue'
export default {
  name: 'investigatingrequest',
  components: {
    addNewUser,
    editUserDetails,
    changePassword
  },
  data () {
    return {
      loading: false,
      usersLoading: false,
      // currentUser: this.$store.getters.GetCurrentUser,
      UpdateUserItem: {},
      changePasswordItem: {
        userName: '',
        id: 0,
        password: '',
        rePassword: ''
      },
      orgUsers: {},
      header: {
        headers: {
          accept: 'text/plain',
          Authorization: 'Bearer ' + this.$store.getters.getAccessToken
        }
      },
      userTableColumns: [
        // {
        //   label: 'მომხმარებლის #',
        //   field: 'id',
        //   thClass: 'e-nusx-8 e-whitespace-nowrap e-ts-08rem',
        //   tdClass: 'e-eng-font e-ts-08rem',
        //   type: 'number'
        // },
        {
          label: 'მომხმარებლის სახელი',
          field: 'firstName',
          thClass: 'e-nusx-8 e-whitespace-nowrap e-ts-08rem',
          tdClass: 'e-nusx-8 e-ts-08rem',
          type: 'text'
        },
        {
          label: 'მომხმარებლის გვარი',
          field: 'lastName',
          thClass: 'e-nusx-8 e-whitespace-nowrap e-ts-08rem',
          tdClass: 'e-nusx-8 e-ts-08rem',
          type: 'text'
        },
        {
          label: 'სისტემის მომხმარებელი',
          field: 'userName',
          tdClass: 'e-eng-font e-ts-08rem e-bold',
          thClass: 'e-nusx-8 e-whitespace-nowrap e-ts-08rem',
          type: 'text'
        },
        // {
        //   label: 'წვდომის ტიპი',
        //   field: 'positionDesc',
        //   thClass: 'e-nusx-8 e-whitespace-nowrap e-ts-08rem',
        //   tdClass: 'e-nusx-8 e-ts-08rem',
        //   type: 'text'
        // },
        {
          label: 'სტატუსი',
          field: 'statusText',
          tdClass: 'e-eng-font e-ts-08rem',
          thClass: 'e-nusx-8 e-whitespace-nowrap e-ts-08rem',
          type: 'text'
        },
        {
          label: 'ფუნქციები',
          field: 'functions',
          tdClass: 'e-eng-font e-ts-08rem',
          thClass: 'e-nusx-8 e-whitespace-nowrap e-ts-08rem',
          type: 'text'
        }
      ],
      userTableRows: []
    }
  },
  computed: {
    currentUser () {
      return this.$store.getters.GetCurrentUser
    }
  },
  created () {
    this.GetOrgUsers()
  },
  methods: {
    GetOrgUsers () {
      this.loading = true
      BaseService.GetSystemUsers(this.header).then((res) => {
        if (res.data.success) {
          this.userTableRows = res.data.result.sort((a, b) => {
            // Prioritize items with status > 0
            if (a.statusID > 0 && b.statusID === 0) return -1
            if (a.statusID === 0 && b.statusID > 0) return 1
            // If both statuses are greater than 0 or both are 0, sort by id
            return a.id - b.id
          })
          this.loading = false
        }
      })
    },
    EditUser (user) {
      user.password = ''
      this.UpdateUserItem = user
    },
    ChangePassword (user) {
      this.changePasswordItem.id = user.id
      this.changePasswordItem.userName = user.userName
    },
    EditUser2Del (user) {
      this.$swal({
        icon: 'danger',
        title: 'ყურადღება!',
        html: '<span class="e-nusx-8 e-ts-09rem">თქვენ აუქმებთ მომხმარებლისთვის წვდომას!</span>',
        showCancelButton: false,
        confirmButtonColor: '#DD6B55',
        confirmButtonText: 'გასაგებია',
        heightAuto: false,
        keydownListenerCapture: true
      }).then((result) => {
        if (result.isConfirmed) {
          user.statusID = 0
          BaseService.EditUser(this.header, user)
            .then(res => {
              if (res.data.success) {
                console.log('გაუქმდა')
                this.GetOrgUsers()
              }
            })
        }
      })
    }
  }
}
</script>
